import type { Locale } from '@/i18n/config'
import type { Messages } from '@/i18n/messages/sq'

import { useRouter } from 'next/router'

import { defaultLocale, toLocale } from '@/i18n/config'
import { sq } from '@/i18n/messages/sq'
import { en } from '@/i18n/messages/en'
import { de } from '@/i18n/messages/de'
import { es } from '@/i18n/messages/es'
import { tr } from '@/i18n/messages/tr'
import { bs } from '@/i18n/messages/bs'
import { ar } from '@/i18n/messages/ar'

export type { Messages }

export const messages: Record<Locale, Messages> = { sq, en, de, es, tr, bs, ar }

export const getMessages = (locale: unknown): Messages => messages[toLocale(locale)]

/** The visitor's portal language, from the address (/de/... → de). Albanian when there is no prefix. */
export const useLocale = (): Locale => {
    const router = useRouter()
    return toLocale(router?.locale ?? defaultLocale)
}

/** The portal copy in the visitor's language. */
export const useT = (): Messages => messages[useLocale()]
